<template>
    
    <div>    
       <!--  <p>Id ES {{$route.params.id}}</p> -->
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a>
                    <router-link :to="{name:'r-/'}">Inicio</router-link>
                </a></li>
                <li class="breadcrumb-item active" aria-current="page">App instalacion</li>
            </ol>
        </nav>
        <div>
            <div class="row">
                <div class="col-12 mt-4">
                    <div class="card">
                        <div class="card-body" style="display:flex; flex-wrap: wrap;">                            
                                                            
                            <div class="row">
                                <!----<div class="col-md-1"></div>-->
                                <div class="col-md-12">
                                    <p id="titulo-1" style="color:white;">
                                        ENU : sistema de administracion
                                    </p>
                                    <p id="titulo-2" style="color:white;">
                                        ENU
                                    </p>
                                    <p id="titulo-3" style="color:white;">
                                        No contiene anuncios - No contiene compras desde la app
                                    </p>
                                    <p id="titulo-4" style="color:white;">
                                        Realiza inscripciones, gestion estudiantil, ofertas educativas y mas.
                                    </p>
                                    <div id="contenedor-logos">
                                        <!----<img src="@/lobato/general/img/logo-3.jpg" alt="logo" style="width:150px; margin-bottom:1em; border-radius: 7px;">-->
                                        <div id="logos-so">
                                            <i class="fa fa-android" aria-hidden="true" style="color:white; margin-right:0.5em; font-size:2em;"></i>
                                            <i class="fa fa-apple" aria-hidden="true" style="color:white; margin-right:0.5em; font-size:2em;"></i>
                                            <i class="fa fa-windows" aria-hidden="true" style="color:white; margin-right:0.5em; font-size:2em;"></i>
                                        </div>
                                    </div>
                                    <div id="contenedor-boton-instalar" style="margin-top:1em;">
                                        <button class="boton-3d-success" type="button" style="width:13em;" @click=instalar_pwa v-if="general.pwa.boton_instalar.mostrar">
                                            <i class='fa fa-plus' aria-hidden='true'></i>
                                            Instalar                                                                                                                
                                        </button>
                                    </div>
                                </div>   
                                
                            </div>      
                                                                                                              
                        </div>
                    </div>
                </div>
            </div>
        </div>        

            
    </div>

</template>

<script>
/* eslint-disable */
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import Swal   from '@/librerias/sweetalert2_9/sweetalert2_9.js'

import * as calculos  from '@/librerias/lobato-calculos.js'

export default {
    name: 'com_general',
    props: {
        msg: String
    },
    data() {
    return {
        datos:{
            evento_instalacion_pwa:'',
            boton_instalar:{
                mostrar:false,
            },
            body:''
        }
    }
    },
    mounted(){
        //this.inicial();
    },
    methods:{
        ...mapMutations(['funciones','alerta']),  
        inicial()
        {          

            /* try {
                window.addEventListener('beforeinstallprompt', (e) => {
                    e.preventDefault();
                    console.log('evento es');
                    console.log(e);
                    this.datos.evento_instalacion_pwa=e;
                    this.datos.boton_instalar.mostrar=true;
                });
            } catch (error) {

            } */ 
        },
        instalar_pwa()
        {
            this.general.pwa.evento_instalacion_pwa.prompt();
            /*
            if (deferredPrompt) 
            {
                // Muestra la ventana de instalación
                deferredPrompt.prompt();
                // Espera a que el usuario responda a la ventana de instalación
                const { outcome } = await deferredPrompt.userChoice;
                console.log(`User response to the install prompt: ${outcome}`);
                // Resetea el deferredPrompt variable
                deferredPrompt = null;
                // Oculta el botón de instalación
                installButton.style.display = 'none';
            }
            */
        }
               
    },
    computed: {
        ...mapState(['general']),
        
    },
    watch: {
        'general.otros.autenticado': function (v) {
            if(v)
            {
                this.inicial();
            }
        }
    }
}
</script>

<style lang="scss" scoped>        
    .contenedor-producto{
        background:linear-gradient(90deg, #0093ff, #484848);
        border-radius:7px; 
        margin-bottom:1em; 
        padding:1em;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.8);
        padding-bottom:0px; 
        padding-top:0.5em;

        /* &:hover{
            background:linear-gradient(90deg, #01253f, #1d1c1c);
        } */

        label {
            color:white;
        }
    }
</style>